import React from 'react'
import styles from './InterviewPrivilege.module.css'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

interface ImageData {
    src: string
    alt: string
}

interface BenefitData {
    id: number
    title: string
    highlightNumber: string
    thumbnailText: string[]
    description: string
    thumbnailClass: string
    images: ImageData[]
}

interface BenefitItemProps {
    benefit: BenefitData
    index: number
}

const BENEFITS_DATA: BenefitData[] = [
    {
        id: 1,
        title: '飲食業界の転職成功事例',
        highlightNumber: '50',
        thumbnailText: ['飲食業界の', '転職成功事例50選'],
        description: '飲食業界の年代別、職種別、業態別の転職成功事例が\nわかるPDFをキャリア面談参加者限定で\n無料でお渡しいたします！',
        thumbnailClass: styles.thumbnail,

        images: [
            { src: '/pages/google/InterviewPrivilege/successStory1.png', alt: '20代調理師の転職成功事例' },
            { src: '/pages/google/InterviewPrivilege/successStory2.png', alt: '30代店長の転職成功事例' },
            { src: '/pages/google/InterviewPrivilege/successStory3.png', alt: '40代エリアマネージャーの転職成功事例' },
            { src: '/pages/google/InterviewPrivilege/successStory4.png', alt: '異業種からの転職成功事例' },
        ],
    },
    {
        id: 2,
        title: '飲食業界の面接質問事例',
        highlightNumber: '50',
        thumbnailText: ['飲食業界の', '面接対策 質問50選'],
        description: '飲食業界の面接で聞かれる想定質問50選の事例が\nわかるPDFをキャリア面談参加者限定で\n無料でお渡しいたします！',
        thumbnailClass: styles.thumbnail2,

        images: [
            { src: '/pages/google/InterviewPrivilege/quetionSample1.png', alt: '面接質問サンプル1' },
            { src: '/pages/google/InterviewPrivilege/quetionSample2.png', alt: '面接質問サンプル2' },
            { src: '/pages/google/InterviewPrivilege/quetionSample3.png', alt: '面接質問サンプル3' },
            { src: '/pages/google/InterviewPrivilege/quetionSample4.png', alt: '面接質問サンプル4' },
        ],
    },
] as const

const BenefitItem: React.FC<BenefitItemProps> = ({ benefit, index }) => {
    const { dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.benefitParts}>
            <h4>
                {benefit.title}<span>{benefit.highlightNumber}</span>選
            </h4>
            <div className={styles.benefitPoint}>
                <div 
                    className={styles.benefitPartCircle}
                    style={{
                        backgroundImage: 'url(/pages/google/InterviewPrivilege/benefitPointCircle.png)'
                    }}
                >
                    特典{index + 1}
                </div>
                <div className={styles.foodCareerPanel}>
                    <div 
                        className={benefit.thumbnailClass}
                        style={{
                            backgroundImage: index === 0 ? 
                                'url(/pages/google/InterviewPrivilege/successStoryThumbnail.png)' :
                                'url(/pages/google/InterviewPrivilege/successStoryThumbnail2.png)'
                        }}
                    >
                        <p className={styles.thumbnailText}>
                            {benefit.thumbnailText.map((text, i) => (
                                <React.Fragment key={i}>
                                    <span>{text}</span>
                                    {i < benefit.thumbnailText.length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </p>
                    </div>
                    {benefit.images.map((image, i) => (
                        <div key={i}>
                            <img src={image.src} alt={image.alt} />
                        </div>
                    ))}
                </div>
                <div className={styles.dottedLine}></div>
                <p className={styles.successStoryNotes}>
                    {benefit.description.split('\n').map((line, i) => (
                        <React.Fragment key={i}>
                            {line.includes('キャリア面談参加者限定') ? (
                                <>
                                    {line.split('キャリア面談参加者限定')[0]}
                                    <span>キャリア面談参加者限定</span>
                                    {line.split('キャリア面談参加者限定')[1]}
                                </>
                            ) : (
                                line
                            )}
                            {i < benefit.description.split('\n').length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </p>
            </div>
            <div className={styles.ctaWrap}>
                <button
                    className={styles.entryButton}
                    data-click-label={dataClickLabel(`CT_Benefits_CVボタン-${index + 1}st`)}
                    onClick={() => {
                        window.location.href = '/signup?channel=googleadwords&p=3&ctaId=' + (index + 3)
                    }}
                >
                    無料でキャリア面談に参加する
                </button>
            </div>
        </div>
    )
}

const InterviewPrivilege = () => {
    const { dataViewLabel } = useAbTestGtm()
    
    return (
        <section data-view-label={dataViewLabel('CT_Benefits')}>
            <div 
                className={styles.InterviewPrivilegeWrap}
                style={{
                    backgroundImage: 'url(/pages/google/InterviewPrivilege/InterviewBenefitsBackground.png)'
                }}
            >
                <div 
                    className={styles.freeBenefitText}
                    style={{
                        backgroundImage: 'url(/pages/google/InterviewPrivilege/freeBenefitLabel.png)'
                    }}
                >
                    <p>無料特典</p>
                </div>

                {BENEFITS_DATA.map((benefit, index) => (
                    <BenefitItem
                        key={benefit.id}
                        benefit={benefit}
                        index={index}
                    />
                ))}
            </div>
        </section>
    )
}

export default InterviewPrivilege
